import React, { useEffect, useState } from 'react';
import { Cnt } from '../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK';
import { BuyButton } from './Buttons/BuyButton';
import { DownloadButton } from './Buttons/DownloadButton';
import { LoginButton } from './Buttons/LoginButton';
import { EMPTY_GUID } from '../types/Guid';
import { ThumbnailProgress } from './ProgressBars/ThumbnailProgress';
import { Col, Row, Spinner } from 'react-bootstrap';
import { ImportButton } from './Buttons/ImportButton';
import { AppSettings } from '../AppSettings';

interface Props {
  model: Cnt.ThreeDeeCrate.SDK.ContainerModelDTO | null;
}

export const ModelModalContent: React.FC<Props> = ({ model }) => {
  const [status, setStatus] = useState<Cnt.ThreeDeeCrate.SDK.ModelStatusType>(
    Cnt.ThreeDeeCrate.SDK.ModelStatusType.IsNotLoggedIn
  );
  const [loadingStatus, setLoadingStatus] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!model?.Container?.Id) return;

      setLoadingStatus(true);
      try {
        const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);
        const modelStatus = await api.model.CheckUserModelStatus({
          Url: window.location.href,
          ContainerId: model.Container.Id,
        });
        setStatus(modelStatus ?? Cnt.ThreeDeeCrate.SDK.ModelStatusType.IsNotLoggedIn);
      } catch (error) {
        console.error('❌ Error refreshing model status', error);
      } finally {
        setLoadingStatus(false);
      }
    };

    fetchStatus();
  }, [model?.Container?.Id]);

  return (
    <>
      <ThumbnailProgress
        containerId={model?.Container?.Id ?? EMPTY_GUID}
        status={model?.Model?.GenerationStatus ?? Cnt.ThreeDeeCrate.SDK.GenerationStatusType.Done}
        smallThumbnail={false}
        isRecommended={model?.Model?.IsRecommended ?? false}
      />

      {model?.Container?.Description && (
        <p className="text-light mt-4">{model?.Container?.Description}</p>
      )}

      {loadingStatus ? (
        <div className="d-flex justify-content-center my-4">
          <Spinner animation="border" variant="light" />
        </div>
      ) : (
        <>
          {/* {status === Cnt.ThreeDeeCrate.SDK.ModelStatusType.Purchased && (
            <p className="text-success mb-3 mt-3">✅ You own this model!</p>
          )} */}

          {status !== Cnt.ThreeDeeCrate.SDK.ModelStatusType.Purchased && (
            <h4 className="text-info fw-bold mb-3">
              ${((model?.Model?.Price || 0) / 100).toFixed(2)}
            </h4>
          )}

          <div className="mb-3">
            <h6 className="fw-semibold">Included Assets:</h6>
            <p>
              {(() => {
                const files = model?.Model?.FileNames ?? '';
                const lowerFiles = files.toLowerCase();

                const assetStatus = [
                  { label: '.obj', found: files.includes('.obj') },
                  { label: '.fbx', found: files.includes('.fbx') },
                  { label: '.dae', found: files.includes('.dae') },
                  { label: 'normal_map', found: lowerFiles.includes('normal') },
                  { label: 'diffuse_map', found: lowerFiles.includes('diffuse') },
                  { label: '.blend', found: files.includes('.blend') },
                ];

                return assetStatus.map((asset, index) => (
                  <span
                    key={index}
                    className={`badge me-1 ${asset.found ? 'bg-secondary' : 'bg-secondary text-muted'}`}
                    style={asset.found ? {} : { opacity: 0.4 }}
                  >
                    {asset.label}
                  </span>
                ));
              })()}
            </p>
          </div>
          {(() => {
            switch (status) {
              case Cnt.ThreeDeeCrate.SDK.ModelStatusType.Purchased:
                return (
                  <Row className="align-items-center">
                    <Col className="d-flex justify-content-start">
                      <DownloadButton containerId={model?.Container?.Id ?? EMPTY_GUID} />
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <ImportButton model={model} />
                    </Col>
                  </Row>
                );
              case Cnt.ThreeDeeCrate.SDK.ModelStatusType.NotPurchased:
                return <BuyButton containerId={model?.Container?.Id ?? EMPTY_GUID} priceId={model?.Model?.StripePriceId ?? ""} />;
              case Cnt.ThreeDeeCrate.SDK.ModelStatusType.IsNotLoggedIn:
                return (
                  <>
                    <span className="text-warning">⚠️ Login required to purchase or download.</span>
                    <div className="mt-3">
                      <LoginButton onSuccess={() => window.location.reload()} />
                    </div>
                  </>
                );
              default:
                return null;
            }
          })()}
        </>
      )}
    </>
  );
};
